import { PhoneNumber } from './PhoneNumber';

export enum NotificationReceiver {
  SMS = '0',
  MailAddress = '1',
  LINE = '2',
  WhatsApp = '3',
}

export enum TwoFactorAuthenticationReceiver {
  SMS = '0',
  MailAddress = '1',
  WhatsApp = '3',
}

export class User {
  public readonly id: string;
  public firstName: string;
  public lastName: string;
  public firstNameKana: string;
  public lastNameKana: string;
  public birthDay: Date;
  public parentalConsent?: ParentalConsent;
  public consentForm?: ConsentForm;
  public phone?: PhoneNumber;
  public notificationReceiver: NotificationReceiver;
  public twoFactorAuthReceiver: TwoFactorAuthenticationReceiver;
  public mailAddress: string;
  public line_id: string;
  public line_nonce: string;

  constructor(
    id: string,
    firstName: string,
    secondName: string,
    firstNameKana: string,
    secondNameKana: string,
    notificationReceiver: NotificationReceiver = NotificationReceiver.SMS,
    twoFactorAuthReceiver: TwoFactorAuthenticationReceiver = TwoFactorAuthenticationReceiver.SMS,
    birthDay: Date,
    mail: string,
    phone?: PhoneNumber,
    parentalConsent?: ParentalConsent, //18歳未満の場合は必須
    consentForm?: ConsentForm,
    line_id?: string,
    line_nonce?: string
  ) {
    this.id = id;
    this.firstName = firstName ?? '';
    this.lastName = secondName ?? '';
    this.firstNameKana = firstNameKana ?? '';
    this.lastNameKana = secondNameKana ?? '';
    this.birthDay = birthDay;
    this.parentalConsent = parentalConsent;
    this.consentForm = consentForm;
    this.phone = phone;
    this.notificationReceiver = notificationReceiver;
    this.twoFactorAuthReceiver = twoFactorAuthReceiver;
    this.mailAddress = mail;
    this.line_id = line_id ?? '';
    this.line_nonce = line_nonce ?? '';
  }

  get fullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  get fullNameKana(): string {
    return this.firstNameKana + ' ' + this.lastNameKana;
  }
}

export enum Gender {
  Male = '0',
  Female = '1',
  NoAnswer = '2',
}

export enum ParentalConsent {
  Yes = '1',
  No = '0',
}
export enum TermOfServiceConsent {
  Yes = '1',
  No = '0',
}
export enum PrivacyNoticeConsent {
  Yes = '1',
  No = '0',
}
export enum SpecificUseConsent {
  Yes = '1',
  No = '0',
}

// stringの場合既にアップロード済みでURLが値として入っている
type ConsentForm = File | string;

/** 18歳未満かどうかを判定する関数
 * @param birthday 誕生日
 * @param now 現在日時
 * @returns 18歳未満の場合はtrue, それ以外はfalse
 */
export function isUnderEighteen(birthday: Date | null, now: Date): boolean {
  if (birthday === null) return false;
  const ageDate = new Date(birthday);
  ageDate.setFullYear(birthday.getFullYear() + 18);

  return ageDate > now;
}

/** 13歳未満かどうかを判定する関数
 * @param birthday 誕生日
 * @param now 現在日時
 * @returns 13歳未満の場合はtrue, それ以外はfalse
 */
export function isUnderThirteen(birthday: Date | null, now: Date): boolean {
  if (birthday === null) return false;
  const ageDate = new Date(birthday);
  ageDate.setFullYear(birthday.getFullYear() + 13);

  return ageDate > now;
}
